/* eslint-disable */

import React, { Component } from 'react';
import { Formik } from 'formik';
import { Box, Button, Card, CardContent, Typography, Alert } from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import OtpInput from 'react-otp-input';
import { Tooltip } from "antd";
import { Info } from '@mui/icons-material';
import OTPServices from '../../services/otp';
import AuthServices from '../../services/auth';

const styles = createStyles(() => ({
    root: {
        margin: '24px 0px'
    },
    titleStyles: {
        fontWeight: 'bold'
    },
    containerStyles: {
        padding: '40px 30px'
    },
    otpTitle: {
        fontSize: '15px'
    }
}));

class OTPCard extends Component {
    constructor(props) {
        super(props);
        const { apiEndpoint, details, sourceDomain } = this.props;
        this.state = {
            otp: '',
            alertType: '',
            apiMessage: '',
            resendBtn: false,
            countdown: 1.3,
            investor_id: details.investor_id,
            investor_email: details.email_address,
            investor_phone_number: details.hasOwnProperty('phone_number')
                ? details.phone_number
                : '',
            sub_register_reference: details.hasOwnProperty('sub_register_reference')
                ? details.sub_register_reference
                : '',
            fund_code: details.hasOwnProperty('fund_code') ? details.fund_code : '',
            username: details.username,
            password: details.password,
            apiEndpoint: apiEndpoint,
            sourceDomain: sourceDomain
        };
    }

    componentDidMount = () => {
        this.disabledResendBtn();
    };

    handleOtpChange = otp => {
        this.setState({
            ...this.state,
            otp: otp
        });
    };

    resendOTP = async () => {
        try {
            if (this.state.apiEndpoint == 'holding') {
                await OTPServices.generateHoldingOTP({
                    investor_id: this.state.investor_id,
                    email: this.state.investor_email,
                    sub_register_reference: this.state.sub_register_reference,
                    fund_code: this.state.fund_code
                });
            } else if (
                this.state.apiEndpoint == 'profile_email' ||
                this.state.apiEndpoint == 'login'
            ) {
                await OTPServices.generateRegisterOTP({
                    email: this.state.investor_email
                });
            } else if (this.state.apiEndpoint == 'profile_sms') {
                await OTPServices.generateRegisterOTPSMS({
                    phone_number: this.state.investor_phone_number
                });
            }
            this.disabledResendBtn();
        } catch (e) {
            let error = e.response.data.message;
            this.setState({
                ...this.state,
                alertType: 'error',
                apiMessage: error
            });
        }
    };

    disabledResendBtn = () => {
        let _timeLeft = 90;

        this.setState({
            ...this.state,
            otp: '',
            resendBtn: false,
            countdown: 1.3,
            alertType: '',
            apiMessage: ''
        });

        let _countdown = setInterval(() => {
            _timeLeft -= 1;
            this.setState({
                ...this.state,
                countdown:
                    _timeLeft == 60
                        ? this.state.countdown - 0.4 - 0.01
                        : this.state.countdown - 0.01
            });
            if (_timeLeft <= 0) {
                clearInterval(_countdown);
                this.setState({
                    ...this.state,
                    resendBtn: true
                });
            }
        }, 1000);
    };

    render() {
        const { classes, navigator, handler, t } = this.props;
        const changeView = (message, route) => {
            this.setState({
                ...this.state,
                otp: '',
                alertType: 'success',
                apiMessage: message
            });
            setTimeout(() => {
                navigator(route, { replace: true });
                if (
                    this.state.apiEndpoint == 'profile_sms' ||
                    this.state.apiEndpoint == 'login'
                ) {
                    handler();
                }
            }, 2000);
        };

        return (
            <Card className={classes.root}>
                <CardContent className={classes.containerStyles}>
                    {this.state.apiMessage != '' && (
                        <Box mb={3}>
                            <Alert severity={this.state.alertType}>{this.state.apiMessage}</Alert>
                        </Box>
                    )}
                    <Box mb={4}>
                        <Typography
                            color="primary"
                            variant="h2"
                            align="center"
                            className={classes.titleStyles}
                        >
                            {'Verification'}
                        </Typography>
                    </Box>
                    <Typography className={classes.otpTitle} align="center" color="textSecondary" gutterBottom>
                        {this.state.apiEndpoint !== "profile_sms" ?
                            'We have sent you an email that contain your OTP to ' + this.state.investor_email + ' .' :
                            'We have sent you an OTP to your mobile number ' + this.state.investor_phone_number + ' .'
                        }
                    </Typography>
                    <Typography className={classes.otpTitle} align="center" color="secondary" gutterBottom>
                        {'Did not receive the OTP? '}
                        <Tooltip
                            placement="bottom"
                            title={this.state.apiEndpoint !== "profile_sms" ? 'Please check your Junk/Spam/Promotions inbox if you did not receive the OTP in your primary inbox.' : 'Please contact us if you want to change your account contact number.'}
                        >
                            <Info />
                        </Tooltip>
                    </Typography>

                    <Formik
                        initialValues={{
                            otp: ''
                        }}
                        onSubmit={async data => {
                            try {
                                if (this.state.apiEndpoint == 'holding') {
                                    const response = await OTPServices.verifyHoldingOTP({
                                        token: this.state.otp
                                    });
                                    let success = response.data.success;
                                    changeView(success, '/investor/my-investments');
                                    await OTPServices.successVerifyHoldingOTP({
                                        email: this.state.investor_email
                                    });
                                } else if (this.state.apiEndpoint == 'profile_email') {
                                    const response = await OTPServices.verifyRegisterOTP({
                                        token: this.state.otp,
                                        email: this.state.investor_email
                                    });
                                    let success = response.data.success;
                                    AuthServices.getUserData({}, apiData => {
                                        if (apiData.status) {
                                            window.opener.postMessage({
                                                event_id: "verify_phone",
                                                user: apiData.data,
                                                message: success
                                            }, this.state.sourceDomain);
                                            setTimeout(function () {
                                                window.self.close();
                                            }, 2000);
                                        }
                                    }
                                    )
                                } else if (this.state.apiEndpoint == 'login') {
                                    const response = await OTPServices.verifyRegisterOTP({
                                        token: this.state.otp,
                                        email: this.state.investor_email
                                    });
                                    let success = response.data.success;
                                    // const loginResponse = await AuthServices.login({
                                    //   'username': this.state.username,
                                    //   'password': this.state.password
                                    // });
                                    // let token = loginResponse.data.access;
                                    // let refresh_token = loginResponse.data.refresh;
                                    // localAuthServices.setLogin(token, refresh_token);
                                    // localStorage.setItem('toRefresh', true);
                                    // localAuthServices.setTokenExpiration();
                                    changeView(success, '/investor/profile');
                                    setTimeout(() => window.location.reload(), 2500);

                                    // changeView(success, '/investor/dashboard');
                                } else if (this.state.apiEndpoint == 'profile_sms') {
                                    const response = await OTPServices.verifyRegisterOTPSMS({
                                        token: this.state.otp,
                                        phone_number: this.state.investor_phone_number
                                    });
                                    let success = response.data.success;
                                    AuthServices.getUserData({}, apiData => {
                                        if (apiData.status) {
                                            window.opener.postMessage({
                                                event_id: "verify_phone",
                                                user: apiData.data,
                                                message: success
                                            }, this.state.sourceDomain);
                                            setTimeout(function () {
                                                window.self.close();
                                            }, 2000);
                                        }
                                    }
                                    )
                                }
                            } catch (e) {
                                console.log(e)
                                let error = e.response.data.message;
                                this.setState({
                                    ...this.state,
                                    otp: '',
                                    alertType: 'error',
                                    apiMessage: error
                                });
                            }
                        }}
                    >
                        {({ handleSubmit, isSubmitting }) => (
                            <form onSubmit={handleSubmit}>
                                <OtpInput
                                    value={this.state.otp}
                                    onChange={this.handleOtpChange}
                                    numInputs={6}
                                    separator={<span>-</span>}
                                    inputStyle={{
                                        width: '2rem',
                                        height: '2rem',
                                        margin: '20px 0.5rem',
                                        fontSize: '1rem',
                                        borderRadius: 4,
                                        border: '2px solid rgba(0,0,0,0.3)',
                                    }}
                                    containerStyle={{
                                        justifyContent: 'center'
                                    }}
                                    shouldAutoFocus={true}
                                    isInputNum={true}
                                />
                                <Box mb={4} textAlign="center">
                                    <Button
                                        color="primary"
                                        disabled={isSubmitting || this.state.otp.length < 6}
                                        size="small"
                                        type="submit"
                                        variant="contained"
                                    >
                                        {'Verify'}
                                    </Button>
                                </Box>
                                <Box my={2} textAlign="center">
                                    <Button
                                        color="primary"
                                        disabled={!this.state.resendBtn}
                                        size="small"
                                        variant="contained"
                                        onClick={this.resendOTP}
                                    >
                                        {this.state.resendBtn ?
                                            <span>Resend OTP</span> :
                                            <span>{this.state.countdown.toFixed(2)}</span>
                                        }
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </CardContent>
            </Card>
        );
    }
}

export default withStyles(styles)(OTPCard);


